module.exports = __webpack_public_path__ + "media/images/facebook-icon-18f8b357b7b86d4afb3533ba45c7fba7.svg";